import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class NavbarService {

  mostrar:boolean =true;
  usuario:String;

  constructor() {
  }
}
